module.exports = [
  "backend.config",
  "DS",
  function(backend, DS) {
    var folder = DS.defineResource({
      name: "folder",
      omit: [/^[$]/],
      idAttribute: "folderId"
    });
    folder.find.before(function(id, opts) {
      opts = opts || {};
      opts.attrs = opts.attrs || {};
      opts.attrs.folderId = id;
      if (id === "/") {
        opts.endpoint =
          opts.endpointOverride ||
          "/hrpolicies/content/" +
            backend.enterprise.code +
            "/" +
            backend.userdata.email;
      } else {
        opts.url =
          folder.basePath +
          (opts.endpointOverride ||
            "/hrpolicies/content/folder/" +
              backend.enterprise.code +
              "/" +
              backend.userdata.email);
        opts.params = {
          folderId: id
        };
      }
      return [id === "/" ? "" : id, opts];
    });

    var document = DS.defineResource({
      name: "document",
      omit: [/^[$]/],
      idAttribute: "documentId",
      adapter: "http",
      stragegy: "single",
      useClass: false,
      keepChangeHistory: false,
      cacheResponse: false,
      instanceEvents: false,
      notify: false,
      watchChanges: false,
      debug: false
    });
    document.find.before(function(id, opts) {
      opts = opts || {};
      opts.attrs = opts.attrs || {};
      opts.attrs.documentId = id;
      if (id === "/") {
        opts.endpoint =
          opts.endpointOverride ||
          "/hrpolicies/content/" +
            backend.enterprise.code +
            "/" +
            backend.userdata.email;
      } else {
        opts.url =
          document.basePath +
          (opts.endpointOverride ||
            "/hrpolicies/content/document/" +
              backend.enterprise.code +
              "/" +
              backend.userdata.email);
        opts.params = {
          documentId: id
        };
      }
      return [id === "/" ? "" : id, opts];
    });

    return {
      Folder: folder,
      Document: document,
      getFolder: function(folderId) {
        folderId = folderId || "/";
        return folder.find(folderId, {}).catch(function(e) {
          console.error(e);
        });
      },
      getDocument: function(info) {
        info.$downloading = true;
        var url =
          document.basePath +
          "/hrpolicies/content/document/" +
          backend.enterprise.code +
          "/" +
          backend.userdata.email;
        return DS.adapters["http"]
          .GET(url, {
            params: {
              documentId: info.id
            },
            responseType: "blob"
          })
          .then(result => {
            // var headers = result.headers();
            var data = result.data;
            return import("../../../../lib/saveas")
              .then(({ saveAs }) => {
                var filename = info.name;
                delete info.$downloading;
                return new DS.utils.Promise((resolve, reject) => {
                  const saver = saveAs(data, filename);
                  saver.onwriteend = resolve;
                });
              })
              .catch(() => {
                delete info.$downloading;
              });
          });
      }
    };
  }
];



// WEBPACK FOOTER //
// ./src/api/js-data/api/content.js